var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.1084 6.25C12.5868 6.25 16.2168 9.88795 16.2168 14.3751C16.2168 18.8624 12.5864 22.5 8.1084 22.5C3.63059 22.5 0 18.8624 0 14.3751C0 9.88806 3.63025 6.25 8.1084 6.25ZM21.0571 6.72591C23.2963 6.72591 25.1114 10.1503 25.1114 14.3751H25.1118C25.1118 18.5989 23.2966 22.0243 21.0576 22.0243C18.8186 22.0243 17.0033 18.5989 17.0033 14.3751C17.0033 10.1514 18.8181 6.72591 21.0572 6.72591H21.0571ZM27.3241 7.52271C28.1114 7.52271 28.75 10.5906 28.75 14.3752C28.75 18.1586 28.1117 21.2277 27.3241 21.2277C26.5365 21.2277 25.8985 18.1595 25.8985 14.3752C25.8985 10.5909 26.5368 7.52271 27.3241 7.52271Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.a2b367b09019904c2778dd21c18d682a.svg";
export { ForwardRef as ReactComponent };